import axios from '@api';
import { transformObjectToSnakeCase } from '@utilities';

import type {
  AutomatedReportSortKey,
  AutomatedReportsResponse,
  AutomatedReportStatus,
} from './types';
import { getAutomatedReportsData } from './utilities/helpers';

interface ReadAutomatedReportsOptions {
  order?: 'asc' | 'desc';
  query?: string;
  sortBy?: AutomatedReportSortKey;
  tags?: AutomatedReportStatus[];
}

export const deleteAutomatedReports = ({ ids }: { ids: Array<number | string> }) => {
  return axios<void>({
    method: 'delete',
    url: `/v2/api/schedules/${ids[0]}`,
    withCredentials: true,
  });
};

export const readAutomatedReports = ({
  order,
  query,
  sortBy,
  tags,
}: ReadAutomatedReportsOptions) => {
  return axios<AutomatedReportsResponse>({
    method: 'get',
    params: transformObjectToSnakeCase({
      orderBy: sortBy ? order : undefined,
      query: query?.length ? query : undefined,
      sortBy,
      tags: tags?.length ? tags.join(',') : undefined,
    }),
    transformResponse: [
      (data: string) =>
        getAutomatedReportsData(JSON.parse(data) as unknown, {
          order,
          query,
          sortBy,
          tags,
        }),
    ],
    url: '/api/schedule/',
    withCredentials: true,
  });
};
